import { apiClient } from "../../api/client";

export interface DeleteTemplatePayload {
  htmlId: string;
  fileId: string;
}

export interface DeleteTemplateResponse {
  message: string;
  success: boolean;
}

export async function deleteTemplate(
  payload: DeleteTemplatePayload
): Promise<DeleteTemplateResponse> {
  try {
    const response = await apiClient.delete<DeleteTemplateResponse>(
      "/PDFConvertor/delete/file",
      {
        data: payload,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting template:", error);
    throw error;
  }
}
